import { render, staticRenderFns } from "./admin-crreate.vue?vue&type=template&id=60c53b22&scoped=true&"
import script from "./admin-crreate.vue?vue&type=script&lang=js&"
export * from "./admin-crreate.vue?vue&type=script&lang=js&"
import style0 from "./admin-crreate.vue?vue&type=style&index=0&id=60c53b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c53b22",
  null
  
)

export default component.exports